import {createContext, useContext} from "react";

export const PermissionContext = createContext({canApproveRegistration:false});
export const usePermissions = ()=>{
    return useContext(PermissionContext)
}